import styled from 'styled-components';

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 16px;
  align-items: center;
`;
